import axios from 'axios';

import axiosInstance from '../api';
import { SessionManager } from '../../utils/SessionManager';
import { 
  FavoriteVideoReq,
  FavoriteVideoRes,
  FavoriteStatusRes,
  FavoriteListRes
} from './favoriteApi.types';

/**
 * お気に入り登録
 */
export const favoriteVideo = async (videoId: string): Promise<FavoriteVideoRes> => {
  const session = SessionManager.getActiveSession();
  const token = session?.token;
  
  if (!token) {
    throw new Error('認証が必要です');
  }
  
  const response = await axios.post<FavoriteVideoRes>(
    '/api/favorites',
    { video_id: videoId } as FavoriteVideoReq,
    { headers: { Authorization: `Bearer ${token}` }}
  );
  return response.data;
};

/**
 * お気に入り解除
 */
export const unfavoriteVideo = async (videoId: string): Promise<FavoriteVideoRes> => {
  const session = SessionManager.getActiveSession();
  const token = session?.token;
  
  if (!token) {
    throw new Error('認証が必要です');
  }
  
  const response = await axios.delete<FavoriteVideoRes>(
    `/api/favorites/${videoId}`,
    { headers: { Authorization: `Bearer ${token}` }}
  );
  return response.data;
};

/**
 * お気に入り状態を確認
 */
export const checkFavoriteStatus = async (videoId: string): Promise<boolean> => {
  const session = SessionManager.getActiveSession();
  const token = session?.token;
  
  if (!token) {
    return false;
  }
  
  try {
    const response = await axios.get<FavoriteStatusRes>(
      `/api/favorites/check/${videoId}`,
      { headers: { Authorization: `Bearer ${token}` }}
    );
    return response.data.is_favorite;
  } catch (error) {
    console.error('お気に入り状態の確認に失敗:', error);
    return false;
  }
};

/**
 * ユーザーのお気に入り一覧取得
 * @deprecated 新しいAPIに移行予定
 */
export const fetchFavorites = async (): Promise<FavoriteListRes> => {
  const response = await axiosInstance.get<FavoriteListRes>('/favorites');
  return response.data;
};

/**
 * お気に入り追加（レガシー関数）
 * @deprecated favoriteVideoを使用してください
 */
export const addFavorite = async (data: FavoriteVideoReq): Promise<FavoriteVideoRes> => {
  const response = await axiosInstance.post<FavoriteVideoRes>('/favorites', data, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**
 * お気に入り削除（レガシー関数）
 * @deprecated unfavoriteVideoを使用してください
 */
export const removeFavorite = async (videoId: string): Promise<FavoriteVideoRes> => {
  const response = await axiosInstance.delete<FavoriteVideoRes>(`/favorites/${videoId}`);
  return response.data;
}; 